<div class="goreact-modal" *ngIf="group$ | async as group">
	<div class="goreact-modal-header">
		<h4 class="modal-title" [innerHTML]="'modal-invite-users_invite-to' | translate: { name: group.name }"></h4>
		<button
			class="close-btn"
			type="button"
			attr.aria-label="{{'common_close' | translate}}"
			role="button"
			(click)="close()">
			<i class="ficon-app-x"></i>
		</button>
	</div>
	<div [formGroup]="form" class="goreact-modal-body">
		<section *ngIf="hasLtiIntegration" class="integration">
			<h3>
				{{ 'modal-invite-users_sure-have-entered-activity' | translate: {'name': group.name} }}
			</h3>
		</section>

		<section *ngIf="!hasLtiIntegration">
			<div class="common-margin" translate="modal-invite_description"></div>

			<div class="invite-content">
				<mat-form-field appearance="outline" floatLabel="always" class="emails common-margin">
					<mat-label translate="modal-invite_email-address"></mat-label>
					<textarea matInput
						formControlName="emails"
						class="fullstory-ignore"
						aria-labelledby="emails-label"
						aria-describedby="emails-error"
						data-cy="invite-users-input"></textarea>
					<mat-hint translate="invite-user-dialog_email-hint"></mat-hint>

					<mat-error
						*ngIf="form.controls.emails.hasError('required')"
						translate="modal-invite-users_controller-email-required">
					</mat-error>
					<mat-error
						*ngIf="form.controls.emails.hasError('multi')"
						class="invalid-email-error">
						{{ 'common-validation_emails-invalid' | translate: { emails: getInvalidEmails() } }}
					</mat-error>
				</mat-form-field>
				<mat-form-field appearance="outline" floatLabel="always" class="role-field">
					<mat-label translate="modal-invite-users_role-label"></mat-label>
					<mat-select
						formControlName="role"
						panelClass="offsetPanel"
						data-cy="invite-users-role"
						required>
						<mat-select-trigger>
							<span>{{ form.get('role').value.title }}</span>
						</mat-select-trigger>
						<mat-option *ngFor="let role of roles" [value]="role">
							<strong>{{ role.title }}</strong>
							<div>{{ role.description }}</div>
						</mat-option>
					</mat-select>
					<mat-icon matIconSuffix class="ficon-app-chevron-down"></mat-icon>

					<mat-error
						*ngIf="form.controls['role'].hasError('required')"
						translate="modmodal-invite-users_controller-role-required">
					</mat-error>
				</mat-form-field>

				<div class="or common-margin" *ngIf="isCourse()">
					<span translate="common_or-uppercase"></span>
				</div>

			</div>

			<section class="link-content" *ngIf="isCourse()">
				<div class="common-margin">
					<div class="link-generator-wrapper common-margin">
						<label *ngIf="group.link" translate="modal-video-share_public-share-link"></label>

						<button
							id="new-tertiary-btn"
							type="button"
							class="btn-none link-button"
							data-cy="create-invite-url"
							(click)="openNewJoinLinkModal()">
							<span *ngIf="!group.link" translate="modal-invite_create-a-public-link"></span>
							<span *ngIf="group.link" translate="generate_new_link"></span>
						</button>

					</div>

					<div class="invite-link-group" *ngIf="group.link">
						<input
							class="form-control invite-url"
							type="url"
							formControlName="link"
							select-all-on="click change"
							data-cy="invite-url"
							readonly="readonly"
							attr.aria-label="{{'common_join-link' | translate}}"/>

						<copy-to-clipboard-wrapper text="{{group.link}}">
							<button
								type="button"
								class="btn-none"
								attr.aria-label="{{'common_copy-course-link' | translate}}">
								<i class="ficon-app-copy"></i>
							</button>
						</copy-to-clipboard-wrapper>
					</div>
				</div>

				<div translate="modal-invite_linking-description"></div>
			</section>
		</section>
	</div>

	<div class="goreact-modal-footer">
		<section class="users-count-wrapper">
			<div class="users-count" *ngIf="group.usersCount && !hasLtiIntegration">
				<i class="ficon-app-users"></i> {{group.usersCount}}
			</div>
		</section>
		<section class="action-buttons">
			<button
				type="button"
				class="secondary-btn close-btn"
				(click)="close()"
				translate="common_close"
				data-cy="invite-modal-close">
			</button>

			<button
				type="button"
				(click)="handleSendInvite()"
				class="primary-btn send-button"
				translate="modal-invite-users_send-invitations"
				*ngIf="showSubmitButton$ | async"
				data-cy="send-invite-btn">
			</button>
		</section>
	</div>
</div>
